export type Size = '2xs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl';

export const matchSize =
    <T extends any>(matchers: Record<'md', T> & Partial<Record<Exclude<Size, 'md'>, T>>) =>
    (size: Size = 'md'): T => {
        const match = matchers[size];
        if (match == null) {
            throw Error(`Missing size declaration: ${size}`);
        }
        return match;
    };

export const Status = {
    success: 'success',
    error: 'error',
    warning: 'warning',
} as const;

export type Status = (typeof Status)[keyof typeof Status];

export type Color = 'base' | 'primary' | 'secondary' | 'tertiary' | 'danger';
